export const STELE_ROUTE_PREFIX = "/stele";

export const STELE_CONSENT_GROUPS = ",C0001,C0002,C0004,";
export const STELE_CONSENT_COOKIE_VALUE = "groups=C0001:1,C0002:1,C0004:1";

export const isSteleRoute = (pathname?: string): boolean => {
    if (!pathname) return false;

    return pathname === STELE_ROUTE_PREFIX || pathname.startsWith(`${STELE_ROUTE_PREFIX}/`);
};

const getConsentExpiry = (): string => {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    return expires.toUTCString();
};

export const buildSteleConsentBootstrapScript = (): string => {
    const expires = getConsentExpiry();

    return `
        (function () {
            var expires = "${expires}";
            document.cookie = "OptanonAlertBoxClosed=" + new Date().toISOString() + "; expires=" + expires + "; path=${STELE_ROUTE_PREFIX}";
            document.cookie = "OptanonConsent=" + encodeURIComponent("${STELE_CONSENT_COOKIE_VALUE}") + "; expires=" + expires + "; path=${STELE_ROUTE_PREFIX}";
            window.OnetrustActiveGroups = "${STELE_CONSENT_GROUPS}";
            window.GDPR = 0;
            window.GDPR_CONSENT_755 = "";
            var event = new CustomEvent("OneTrustGroupsUpdated");
            event.details = "${STELE_CONSENT_GROUPS}";
            window.dispatchEvent(event);
        })();
    `;
};

export const applySteleConsentDefaults = (): void => {
    if (typeof window === "undefined") return;

    const expires = getConsentExpiry();

    document.cookie = `OptanonAlertBoxClosed=${new Date().toISOString()}; expires=${expires}; path=${STELE_ROUTE_PREFIX}`;
    document.cookie = `OptanonConsent=${encodeURIComponent(STELE_CONSENT_COOKIE_VALUE)}; expires=${expires}; path=${STELE_ROUTE_PREFIX}`;
    window.OnetrustActiveGroups = STELE_CONSENT_GROUPS;
    window.GDPR = 0;
    window.GDPR_CONSENT_755 = "";

    const event = new Event("OneTrustGroupsUpdated") as Event & { details: string };
    event.details = STELE_CONSENT_GROUPS;
    window.dispatchEvent(event);
};

export const hideOneTrustUi = (): void => {
    if (typeof document === "undefined") return;

    const selectors = ["#onetrust-consent-sdk", "#onetrust-banner-sdk", "#onetrust-pc-sdk", "#ot-sdk-btn-floating"];

    for (const selector of selectors) {
        document.querySelectorAll(selector).forEach((element) => element.remove());
    }

    document.body.classList.add("stele-route");
    document.body.style.overflow = "auto";
    document.body.style.paddingRight = "0";
};
